import React from "react";
import PropTypes from "prop-types";
import { HISTORIC_GUARDIAN_BOND } from "../historicGuardianConfig";
import HistoricGuardianFormBase from "./HistoricGuardianFormBase";
import VAHistoricGoogleAutoComplete from "./VAHistoricGoogleAutoComplete";
import VAHistoricLabeledCreatableSelect from "./VAHistoricLabeledCreatableSelect";
import { scrollToTop } from "../../../../features/bonds/shared/formHelpers";

export default function VAHistoricGuardianForm(props) {
  return (
    <HistoricGuardianFormBase
      bondKind={HISTORIC_GUARDIAN_BOND.va}
      GoogleAutoComplete={VAHistoricGoogleAutoComplete}
      LabeledCreatableSelect={VAHistoricLabeledCreatableSelect}
      scrollToTop={scrollToTop}
      {...props}
    />
  );
}

VAHistoricGuardianForm.propTypes = {
  data: PropTypes.shape({ guardians: PropTypes.array }),
  updateData: PropTypes.func.isRequired,
  globalData: PropTypes.object.isRequired,
  errors: PropTypes.object,
};
